import { getMetadata } from '~loader/loader-utils';
import { getSelectedPagesByUser } from '../../getSelectedPagesByUser';
import { getUser } from '~src/user';
import { getGridParameters } from '~core/grigliaProvino';
import { generateGridWithFixedMargins } from './generateGridWithFixedMargins';

// Taglierina Memento di Santini (PE-1406) - A4 Orizzontale
// Configurazione di un singolo cliente, non un formato generico "taglierina
// Memento": le misure qui sotto sono le leve impostate sulla macchina di
// Santini. Un altro cliente con la stessa macchina ma impostata diversamente
// deve avere un layout e un id propri.
// Ricordini da 5,7 x 8,8 cm (57 x 88 mm), 5 colonne x 2 righe = 10 per foglio.
// Geometria ripresa dal provino PDF inviato dal cliente: le foto sono un
// blocco unico, senza alcuno spazio tra colonne e tra righe.
//   5 colonne da 57mm = 285mm -> blocco centrato in orizzontale (8mm per lato)
//   2 righe da 88mm = 176mm -> blocco a 18mm dal bordo superiore
const staticGridParameters = {
  pdf: {
    topMargin: 18,
    leftMargin: 8,
  },
  rowInfo: {
    maxItemsToFit: 5,
    padding: 0, // nessuna spaziatura orizzontale tra colonne
  },
  columnInfo: {
    maxItemsToFit: 2,
    padding: 0, // nessuna spaziatura verticale tra righe
  },
};

export default async function generateGrid() {
  const metadata = getMetadata();
  const selectedPagesByUser = getSelectedPagesByUser();

  const { user } = await getUser();

  const gridParameters = getGridParameters();

  return generateGridWithFixedMargins({
    staticGridParameters,
    gridParameters,
    selectedPagesByUser,
    metadata,
    user,
  });
}
